<template>
    <div class="apprentice-simple-card">
        <div
            class="student-cohorts-overview"
            v-if="sluStudentIn.slu_cohorts.length > 0">
            <div class="student-cohorts-overview-header">
                <div class="student-progress h4">
                    {{
                        $t('slu_dashboard.total_achieved_points', {
                            points_name: sluSchoolSettingsIn.name_points,
                        })
                    }}: {{ getCoursesProgress }}
                </div>
                <b-form-select
                    class="apprentice-primary-select with-border student-slu-season-select"
                    v-model="selectedSeasonId"
                    :options="seasonOptions">
                </b-form-select>
            </div>

            <div
                class="row"
                v-if="courses.length !== 0">
                <div
                    class="col-21 col-md-6 col-xxl-3 slu-course"
                    v-for="course of courses"
                    :key="course.id">
                    <design-2021-slu-student-course-card-component
                        :course-in="course"
                        :slu-student-in="sluStudentIn"
                        :slu-school-settings-in="sluSchoolSettingsIn"
                        :selected-season-id-in="selectedSeasonId">
                    </design-2021-slu-student-course-card-component>
                </div>
            </div>

            <div
                class="not-found with-header empty-filter"
                v-else>
                <div class="icon">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="alert-notice">
                    {{
                        selectedSeasonId
                            ? $t('slu_dashboard.no_modules_found_for_the_chosen_school_year')
                            : $t('slu_dashboard.no_modules_found')
                    }}
                </div>
            </div>
        </div>

        <div
            class="not-found with-header not-yet-assigned"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">
                {{ $t('slu_dashboard.you_do_not_have_access_to_the_module_yet_ask_your_coordinator_for_access') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-student-index-component',
    props: ['sluStudentIn', 'sluCoursesIn', 'sluSchoolSettingsIn', 'seasonsIn', 'currentSeasonId'],
    data() {
        return {
            user: this.sluStudentIn,
            selectedSeason: null,
            selectedSeasonId: 0,
            courseFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'progress',
                    label: this.$t('slu_dashboard.progress'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    mounted() {
        if (this.seasonsIn.length > 0) {
            if (this.seasonsIn.find((season) => season.id === this.currentSeasonId)) {
                this.selectedSeasonId = this.currentSeasonId;
            }
        }
    },

    computed: {
        courses() {
            let courses = [];
            if (this.selectedSeasonId === 0) {
                courses = this.sluCoursesIn
                    .map((course) => {
                        let cohorts = this.sluStudentIn.slu_cohorts
                            .filter(function (cohort) {
                                return cohort.slu_course_id === course.id;
                            })
                            .map((cohort) => {
                                if (cohort.slu_course_id === course.id) {
                                    return cohort;
                                }
                            });
                        let modules = cohorts
                            .map((sluCohort) => {
                                return sluCohort.modules;
                            })
                            .flat();
                        let totalHours = modules
                            .map((module) => {
                                return module.required ? module.hours : 0;
                            })
                            .reduce((partialSum, a) => partialSum + a, 0);
                        let completedHours = 0;
                        let totalBonusHours = modules
                            .map((module) => {
                                return !module.required ? module.hours : 0;
                            })
                            .reduce((partialSum, a) => partialSum + a, 0);
                        let completedBonusHours = 0;
                        modules.forEach((module) => {
                            if (module.slu_module_records) {
                                module.slu_module_records.forEach((record) => {
                                    if (record.completed) {
                                        if (module.required) {
                                            completedHours += module.hours;
                                        } else {
                                            completedBonusHours += module.hours;
                                        }
                                    }
                                });
                            }
                        });
                        let imagePath = course.file ? course.file.path : course.course.image;
                        return {
                            id: course.id,
                            name: course.course.name,
                            totalHours: totalHours,
                            completedHours: completedHours,
                            completedBonusHours: completedBonusHours,
                            image: imagePath,
                            totalBonusHours,
                        };
                    })
                    .sort((a, b) => a.name.localeCompare(b.name));
            } else {
                courses = this.sluCoursesIn
                    .map((course) => {
                        let cohorts = this.sluStudentIn.slu_cohorts
                            .filter((cohort) => {
                                return cohort.slu_course_id === course.id && cohort.season_id === this.selectedSeasonId;
                            })
                            .map((cohort) => {
                                if (cohort.slu_course_id === course.id) {
                                    return cohort;
                                }
                            });
                        let modules = cohorts
                            .map((sluCohort) => {
                                return sluCohort.modules;
                            })
                            .flat();
                        let totalHours = modules
                            .map((module) => {
                                return module.required ? module.hours : 0;
                            })
                            .reduce((partialSum, a) => partialSum + a, 0);
                        let totalBonusHours = modules
                            .map((module) => {
                                return !module.required ? module.hours : 0;
                            })
                            .reduce((partialSum, a) => partialSum + a, 0);
                        let completedHours = 0;
                        let completedBonusHours = 0;
                        modules.forEach((module) => {
                            if (module.slu_module_records) {
                                module.slu_module_records.forEach((record) => {
                                    if (record.completed) {
                                        if (module.required) {
                                            completedHours += module.hours;
                                        } else {
                                            completedBonusHours += module.hours;
                                        }
                                    }
                                });
                            }
                        });
                        let imagePath = course.file ? course.file.path : course.course.image;
                        return {
                            id: course.id,
                            name: course.course.name,
                            totalHours: totalHours,
                            completedHours: completedHours,
                            completedBonusHours: completedBonusHours,
                            image: imagePath,
                            totalBonusHours,
                        };
                    })
                    .sort((a, b) => a.name.localeCompare(b.name));
            }

            if (courses.length > 0) {
                courses = courses.filter((course) => course.totalHours > 0);
            }

            return courses;
        },

        seasonOptions() {
            let seasonOptions = this.seasonsIn.map((season) => {
                return {
                    value: season.id,
                    text: season.season,
                };
            });
            seasonOptions.push({
                value: 0,
                text: this.$t('slu_dashboard.everything'),
            });

            return [...seasonOptions.reverse()];
        },

        getCoursesProgress() {
            if (this.courses.length === 0) {
                return `0 ${this.sluSchoolSettingsIn.name_points}`;
            }

            let totalHours = 0;
            let totalCompletedHours = 0;
            let totalBonusHours = 0;
            let totalCompletedBonusHours = 0;

            for (const course of this.courses) {
                totalHours += course.totalHours;
                totalCompletedHours += course.completedHours;
                totalBonusHours += course.totalBonusHours;
                totalCompletedBonusHours += course.completedBonusHours;
            }

            const totalPoints = (totalHours + totalBonusHours) / this.sluSchoolSettingsIn.hours_to_point;
            const completedPoints =
                (totalCompletedHours + totalCompletedBonusHours) / this.sluSchoolSettingsIn.hours_to_point;

            return `${completedPoints}/${totalPoints} ${this.sluSchoolSettingsIn.name_points}`;
        },
    },

    methods: {
        openCourse(sluCourseId) {
            if (this.$authUser.isAdmin() || this.$authUser.isTeacher()) {
                window.location.href = this.routes.sluStudentCourse(this.sluStudentIn.id, sluCourseId);
            } else {
                window.location.href = this.routes.studentSluCourse(sluCourseId);
            }
        },
        changeSeason() {
            this.selectedSeason = this.seasonsIn.find((season) => season.id === this.selectedSeasonId);
        },
    },
};
</script>

<style scoped lang="scss">
.student-cohorts-overview-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.student-progress {
    align-self: flex-start;
    margin-bottom: 0;
}

.student-slu-season-select {
    margin-bottom: 0;
}

.slu-course {
    margin-bottom: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .student-cohorts-overview-header {
        .student-slu-season-select {
            width: auto;
            max-width: 250px;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .student-cohorts-overview-header {
        flex-direction: row;
    }

    .student-progress {
        align-self: center;
    }

    .student-slu-season-select {
        width: auto;
        max-width: 300px;
        margin-left: auto;
    }
}
</style>
